{
	"title": "Facturen",
	"buttonShowMoreInvoicesTitle": "Meer facturen tonen",
	"invoicesTableHeaders": {
		"date": "Datum",
		"invoiceNumber": "Factuurnummer",
		"deliveredQuantity": "Geleverde hoeveelheid",
		"bundledCarbonSavings": "Gebundelde CO\u2082-reducties",
		"transactionId": "Transactie-ID"
	},
	"errorMessage": "Facturen konden niet worden geladen"
}
